import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "../css/Facility.css";
import {
  FaBed,
  FaCoffee,
  FaWifi,
  FaHotTub,
  FaTv,
  FaSwimmingPool,
  FaBuilding,
  FaChild,
  FaParking,
} from "react-icons/fa";

const Facility = () => {
  return (
    <div className="container" style={{ marginTop: "80px" }}>
      <h1 className="text-center fw-bold text-primary mb-5">Fasilitas Utama</h1>
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow-lg border-0 rounded-4 animate__animated animate__fadeInUp fasilitas-card">
            <img
              src="../assets/swimming-pool.jpeg"
              alt="Kolam Renang Air Panas"
              className="card-img-top fasilitas-img"
            />
            <div className="card-body">
              <h2 className="card-title fw-bold text-dark">
                Kolam Renang Air Panas
              </h2>
              <p className="card-text text-secondary">
                Nikmati relaksasi maksimal di kolam renang dengan air panas yang
                menyegarkan, lengkap dengan fasilitas modern yang dirancang
                untuk kenyamanan Anda.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-lg border-0 rounded-4 animate__animated animate__fadeInUp p-4">
            <h2 className="fw-bold text-dark mb-4">Fasilitas Lainnya</h2>
            <ul className="list-unstyled fasilitas-list">
              <li className="d-flex align-items-center mb-3">
                <FaWifi className="me-3 text-primary" size={24} />
                <span>Free Wifi</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <FaParking className="me-3 text-primary" size={24} />
                <span>Parking Area</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <FaHotTub className="me-3 text-primary" size={24} />
                <span>Hot Water</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <FaTv className="me-3 text-primary" size={24} />
                <span>Smart TV (Access YouTube, Netflix)</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <FaSwimmingPool className="me-3 text-primary" size={24} />
                <span>Swimming Pool</span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <FaBuilding className="me-3 text-primary" size={24} />
                <span>Balcony</span>
              </li>
              <li className="d-flex align-items-center">
                <FaChild className="me-3 text-primary" size={24} />
                <span>Playground</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facility;
